import NotFound from 'modules/core/components/NotFound'
import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onClose: () => void
}

export const ReconciliationNotFound = ({ onClose }: Props) => {
  return (
    <Sidepanel
      title={i18n.t('finance.reconciliations.sidepanel_title')}
      width="extended"
      open
      onClose={onClose}
    >
      <NotFound />
    </Sidepanel>
  )
}
